import React from 'react'
import moment from 'moment'
import newUserBadge from './themes/new-badge.css'

export default function NewBadge({ key, created_at }) {
  const currentDate = moment(new Date());
  const createdDate = moment(created_at, "YYYY-MM-DD HH:mm:ss");
  return currentDate.diff(createdDate, 'days') <= 3 ? <div key={key} className={newUserBadge.badge}>NEW</div> : null;
}


// WEBPACK FOOTER //
// ./src/web/components/new-badge.jsx